export const translations = {
  es: {
    // Navigation
    nav: {
      manifesto: "Manifiesto",
      products: "Productos",
      specs: "Especificaciones",
      gallery: "Galería",
      contact: "Contacto",
    },
    // Hero
    hero: {
      title: "MAGNA",
      subtitle: "SILENCIOSAMENTE IMPONENTE",
      cta: "DESCUBRIR MAGNA",
      scroll: "Desliza para explorar",
    },
    // Manifesto
    manifesto: {
      title: "El verdadero lujo no grita. Se siente.",
      content: [
        "MAGNA es la máxima expresión de Morelli. Donde la ingeniería profesional se encuentra con la sofisticación extrema. Diseñada para quienes entienden que la cocina no es solo un lugar, es un escenario. No necesita convencer. Su presencia en un espacio lo transforma. Su calidad no se explica, se siente. Su carácter no se impone, se reconoce.",
      ],
      tagline: "Profesional por origen. Premium por ejecución.",
    },
    // Products
    products: {
      title: "LA LÍNEA",
      subtitle: "Dos expresiones de excelencia",
      magna1200: {
        name: "MAGNA 1200",
        description: "120 cm de dominio absoluto. La máxima expresión del poder culinario profesional en el ámbito doméstico.",
        features: [
          "6 quemadores profesionales Sabaf",
          "Horno a gas con piedra refractaria napolitana",
          "Horno eléctrico Airfryer turbo convección",
          "Chapa bistequera con quemador en U",
        ],
      },
      magna900: {
        name: "MAGNA 900",
        description: "87 cm de precisión refinada. Todo el carácter profesional en un formato optimizado.",
        features: [
          "6 quemadores profesionales Sabaf",
          "Horno a gas de 97 litros",
          "Piedra refractaria napolitana incluida",
          "Grill eléctrico superior",
        ],
      },
      cta: "VER ESPECIFICACIONES",
    },
    // Specs
    specs: {
      title: "ESPECIFICACIONES",
      subtitle: "Precisión técnica",
      categories: {
        dimensions: "Dimensiones",
        power: "Potencia",
        materials: "Materiales",
        features: "Características",
      },
      items: {
        width: "Ancho",
        depth: "Profundidad",
        height: "Alto",
        burners: "Quemadores",
        ovenCapacity: "Capacidad Horno",
        maxTemp: "Temp. Máxima",
        material: "Acero Inox 304",
        burnerType: "Sabaf Aluminio",
        grates: "Hierro Fundido",
        coating: "Cerámico Easy Clean",
        ignition: "Encendido Eléctrico",
        safetyValve: "Válvula Seguridad",
        gasType: "GLP/GN Compatible",
        warranty: "Garantía Extendida",
      },
    },
    // Gallery
    gallery: {
      title: "GALERÍA",
      subtitle: "Donde el fuego obedece",
    },
    // Contact
    contact: {
      title: "ASESORAMIENTO EXCLUSIVO",
      subtitle: "Comience su experiencia MAGNA",
      form: {
        name: "Nombre completo",
        email: "Email",
        phone: "Teléfono",
        product: "Producto de interés",
        selectProduct: "Seleccione un producto",
        message: "Mensaje (opcional)",
        messagePlaceholder: "Cuéntenos sobre su proyecto...",
        submit: "SOLICITAR COTIZACIÓN",
        submitting: "ENVIANDO...",
        success: "Solicitud enviada correctamente",
        successMessage: "Nos pondremos en contacto pronto.",
        error: "Error al enviar",
        errorMessage: "Intente nuevamente más tarde.",
      },
      products: {
        magna1200: "MAGNA 1200",
        magna900: "MAGNA 900",
        both: "Ambos modelos",
        undecided: "Aún no decidido",
      },
    },
    // Footer
    footer: {
      tagline: "Profesional por origen. Premium por ejecución.",
      rights: "Todos los derechos reservados.",
      privacy: "Privacidad",
      terms: "Términos",
    },
  },
  pt: {
    // Navigation
    nav: {
      manifesto: "Manifesto",
      products: "Produtos",
      specs: "Especificações",
      gallery: "Galeria",
      contact: "Contato",
    },
    // Hero
    hero: {
      title: "MAGNA",
      subtitle: "SILENCIOSAMENTE IMPONENTE",
      cta: "DESCOBRIR MAGNA",
      scroll: "Deslize para explorar",
    },
    // Manifesto
    manifesto: {
      title: "O verdadeiro luxo não grita. Se sente.",
      content: [
        "MAGNA é a máxima expressão da Morelli. Onde a engenharia profissional encontra a sofisticação extrema. Projetada para quem entende que a cozinha não é apenas um lugar, é um palco. Não precisa convencer. Sua presença em um espaço o transforma. Sua qualidade não se explica, se sente. Seu caráter não se impõe, se reconhece.",
      ],
      tagline: "Profissional por origem. Premium por execução.",
    },
    // Products
    products: {
      title: "A LINHA",
      subtitle: "Duas expressões de excelência",
      magna1200: {
        name: "MAGNA 1200",
        description: "120 cm de domínio absoluto. A máxima expressão do poder culinário profissional no âmbito doméstico.",
        features: [
          "6 queimadores profissionais Sabaf",
          "Forno a gás com pedra refratária napolitana",
          "Forno elétrico Airfryer turbo convecção",
          "Chapa bistequeira com queimador em U",
        ],
      },
      magna900: {
        name: "MAGNA 900",
        description: "87 cm de precisão refinada. Todo o caráter profissional em um formato otimizado.",
        features: [
          "6 queimadores profissionais Sabaf",
          "Forno a gás de 97 litros",
          "Pedra refratária napolitana incluída",
          "Grill elétrico superior",
        ],
      },
      cta: "VER ESPECIFICAÇÕES",
    },
    // Specs
    specs: {
      title: "ESPECIFICAÇÕES",
      subtitle: "Precisão técnica",
      categories: {
        dimensions: "Dimensões",
        power: "Potência",
        materials: "Materiais",
        features: "Características",
      },
      items: {
        width: "Largura",
        depth: "Profundidade",
        height: "Altura",
        burners: "Queimadores",
        ovenCapacity: "Capacidade Forno",
        maxTemp: "Temp. Máxima",
        material: "Aço Inox 304",
        burnerType: "Sabaf Alumínio",
        grates: "Ferro Fundido",
        coating: "Cerâmico Easy Clean",
        ignition: "Ignição Elétrica",
        safetyValve: "Válvula Segurança",
        gasType: "GLP/GN Compatível",
        warranty: "Garantia Estendida",
      },
    },
    // Gallery
    gallery: {
      title: "GALERIA",
      subtitle: "Onde o fogo obedece",
    },
    // Contact
    contact: {
      title: "ASSESSORIA EXCLUSIVA",
      subtitle: "Comece sua experiência MAGNA",
      form: {
        name: "Nome completo",
        email: "Email",
        phone: "Telefone",
        product: "Produto de interesse",
        selectProduct: "Selecione um produto",
        message: "Mensagem (opcional)",
        messagePlaceholder: "Conte-nos sobre seu projeto...",
        submit: "SOLICITAR ORÇAMENTO",
        submitting: "ENVIANDO...",
        success: "Solicitação enviada com sucesso",
        successMessage: "Entraremos em contato em breve.",
        error: "Erro ao enviar",
        errorMessage: "Tente novamente mais tarde.",
      },
      products: {
        magna1200: "MAGNA 1200",
        magna900: "MAGNA 900",
        both: "Ambos modelos",
        undecided: "Ainda não decidido",
      },
    },
    // Footer
    footer: {
      tagline: "Profissional por origem. Premium por execução.",
      rights: "Todos os direitos reservados.",
      privacy: "Privacidade",
      terms: "Termos",
    },
  },
  en: {
    // Navigation
    nav: {
      manifesto: "Manifesto",
      products: "Products",
      specs: "Specifications",
      gallery: "Gallery",
      contact: "Contact",
    },
    // Hero
    hero: {
      title: "MAGNA",
      subtitle: "SILENTLY IMPOSING",
      cta: "DISCOVER MAGNA",
      scroll: "Scroll to explore",
    },
    // Manifesto
    manifesto: {
      title: "True luxury doesn't shout. It's felt.",
      content: [
        "MAGNA is the ultimate expression of Morelli. Where professional engineering meets extreme sophistication. Designed for those who understand that the kitchen is not just a place, it's a stage. It doesn't need to convince. Its presence transforms a space. Its quality isn't explained, it's felt. Its character isn't imposed, it's recognized.",
      ],
      tagline: "Professional by origin. Premium by execution.",
    },
    // Products
    products: {
      title: "THE LINE",
      subtitle: "Two expressions of excellence",
      magna1200: {
        name: "MAGNA 1200",
        description: "120 cm of absolute mastery. The ultimate expression of professional culinary power in the domestic realm.",
        features: [
          "6 Sabaf professional burners",
          "Gas oven with Neapolitan refractory stone",
          "Electric turbo convection Airfryer oven",
          "Griddle plate with U-shaped burner",
        ],
      },
      magna900: {
        name: "MAGNA 900",
        description: "87 cm of refined precision. All the professional character in an optimized format.",
        features: [
          "6 Sabaf professional burners",
          "97-liter gas oven",
          "Neapolitan refractory stone included",
          "Upper electric grill",
        ],
      },
      cta: "VIEW SPECIFICATIONS",
    },
    // Specs
    specs: {
      title: "SPECIFICATIONS",
      subtitle: "Technical precision",
      categories: {
        dimensions: "Dimensions",
        power: "Power",
        materials: "Materials",
        features: "Features",
      },
      items: {
        width: "Width",
        depth: "Depth",
        height: "Height",
        burners: "Burners",
        ovenCapacity: "Oven Capacity",
        maxTemp: "Max Temp.",
        material: "Stainless Steel 304",
        burnerType: "Sabaf Aluminum",
        grates: "Cast Iron",
        coating: "Ceramic Easy Clean",
        ignition: "Electric Ignition",
        safetyValve: "Safety Valve",
        gasType: "LPG/NG Compatible",
        warranty: "Extended Warranty",
      },
    },
    // Gallery
    gallery: {
      title: "GALLERY",
      subtitle: "Where fire obeys",
    },
    // Contact
    contact: {
      title: "EXCLUSIVE CONSULTATION",
      subtitle: "Begin your MAGNA experience",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        product: "Product of interest",
        selectProduct: "Select a product",
        message: "Message (optional)",
        messagePlaceholder: "Tell us about your project...",
        submit: "REQUEST QUOTE",
        submitting: "SENDING...",
        success: "Request sent successfully",
        successMessage: "We will contact you soon.",
        error: "Error sending",
        errorMessage: "Please try again later.",
      },
      products: {
        magna1200: "MAGNA 1200",
        magna900: "MAGNA 900",
        both: "Both models",
        undecided: "Not yet decided",
      },
    },
    // Footer
    footer: {
      tagline: "Professional by origin. Premium by execution.",
      rights: "All rights reserved.",
      privacy: "Privacy",
      terms: "Terms",
    },
  },
};

export const getTranslation = (lang, path) => {
  const keys = path.split('.');
  let result = translations[lang];
  for (const key of keys) {
    result = result?.[key];
  }
  return result || path;
};
